import React, { useState } from 'react';
import { useData } from '../DataHook';
import { ButtonGroup, Container, Button, Modal, Badge } from 'react-bootstrap';

export default function () {
  const { undo, redo, clear } = useData();
  const [showInfoModal, setShowInfoModal] = useState(false);

  return <>
    <Container className="pt-2 pb-2 utils-buttons">
      <ButtonGroup className="btn-block" aria-label="Utils">
        <Button variant="warning" className="text-white" onClick={() => undo()}>Undo</Button>
        <Button variant="success" onClick={() => redo()}>Redo</Button>
        <Button variant="danger" onClick={() => clear()}>Clear</Button>
        <Button variant="outline-primary" onClick={() => setShowInfoModal(true)}>More</Button>
      </ButtonGroup>
    </Container>

    <Modal show={showInfoModal} onHide={() => setShowInfoModal(false)} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Modal heading</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>How to use</h4>
        <p>Click the <Badge className="bg-success">Green</Badge> buttons to add that to the counts. Clicking <Badge className="bg-success">Custom</Badge> will allow you to add the item using a slider, click the <input type="radio" />'s to change the unit.</p>
        <p>When done with counting stock, the total amount of each item will be shown below it's buttons for you to enter into eRestaurant.</p>
        <p>After puttin' counts into eRestaurant you may press <Badge className="bg-danger">Clear</Badge> to reset the counts on the app</p>
        <p>Make a mistake? we all do. Press <Badge className="bg-warning">Undo</Badge> and <Badge className="bg-success">Redo</Badge> to fix those mistakes.</p>
        <hr />
        <h4>Planned Features</h4>
        <ul>
          <li>More <small>(All)</small> Items</li>
          <li>Settings</li>
          <li>Cleaner UI</li>
          <li>eRestaurant integration?</li>
          <li>Sharing past counts with rest of team</li>
          <li>Printing the counts</li>
          <li>Saving counts to link</li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowInfoModal(false)}>
          Close
          </Button>
      </Modal.Footer>
    </Modal>
  </>;
}